import React from 'react'
import "./offer.css";
import Navbar from '../Home/Navbar';

// make a separate fucntional component and form this component. Code should always DRY property
export const Offer = () => {
  return (
    <>
    <Navbar/>
  
    <div className="offer">
     <div id="offercontainer">
      <div id="home">Home<span> PharmEasy Coupon Codes & Offers</span>
      <h1>PharmaEasy Offers & Coupon Codes</h1></div>
      <p>PharmEasy is one of India’s leading online healthcare platforms that allows you to make great savings on your medicines and healthcare needs every day.From finding the prescribed medicine you need to the wellness product that is best suitable for you... 
      </p>
      <h4>Download the PharmEasy app today to buy medicines online with great savings.</h4>
      <h4>Hurry! Avail these exclusive PharmEasy offers now.</h4>
      <div id="button">
      <button className='a1' id='fst'>All</button>
      <button className='a1'>Payment</button>
      <button className='a1'>Medicine</button>
      <button className='a1'>Diagnostics</button>
      <button className='a1'>Healthcare</button>

      </div>
      <div id="blocks">
      <div className="box">
      <div id="b2" className="b11">
      <img src="https://cms-contents.pharmeasy.in/offer/1cc6737ebd0-PELOGO.png?dim=60x0&dpr=1.2799999713897705&q=100" alt="logo2 "/>
      <div className="off">
      <h3>Assured PE Cashback upto ₹5000</h3>
      <br/>
      <p>Get assured PE Cashback upto ₹5000.Minimum cart value must be ₹1499.Cashback will be credited 10 day...</p>
      </div>
      </div>
      </div>
      <div className="box">
      <div id="b3" className="b11">
      <img src="https://cms-contents.pharmeasy.in/offer/ff883fda5e7-8cb6aca7321-73c00e2e5dc-Myntra-13%20(1).png?dim=60x0&dpr=1.2799999713897705&q=100" alt="logo3"/>
      <div className="off">
      <h3>Flat 20%off+20% cashback on all medicines+Myntra voucher worth Rs.250</h3>
      <p>Flat 20% off+Additional 20% cashback upto Rs.600 on your 1st medicine order</p>
      <h6>Expiring in<br/> 5 days</h6>
      </div>
      </div>
      </div> 
      <div className="box">  
      <div id="b4" className="b11">
      <img src="https://cms-contents.pharmeasy.in/offer/2cba8563fe9-GROFFERS.png?dim=60x0&dpr=1.2799999713897705&q=100" alt="logo4"/>
      <div className="off">
      <h3>Flat 20%off+20% cashback on all medicines+Myntra voucher worth Rs.250</h3>
      <p>Flat 20% off+Additional 20% cashback upto Rs.600 on your 1st medicine order</p>
      <h6>Expiring in <br/>2 days</h6>
      </div>
      </div>
      {/* <div className="code"><p>GRFRIPL</p>
      </div> */}
      </div>
      <div className="box"> 
      <div id="b5" className="b11">
      <img src="https://cms-contents.pharmeasy.in/offer/195fbaea221-8b9fd08f47e-LOGO-33%20(1).png?dim=60x0&dpr=1.2799999713897705&q=100" alt="logo5"/>
      <div className="off">
      <h3>Flat 20%off+20% cashback on all medicines+Myntra voucher worth Rs.250</h3>
      <p>Flat 20% off+Additional 20% cashback upto Rs.600 on your 1st medicine order</p>
      <h6>Expiring in<br/> 4 days</h6>
      </div>
      </div>
      </div>

      <div className="box">
      <div id="b6" className="b11">
      <img src="https://cms-contents.pharmeasy.in/offer/29e0c8c1469-LOGO_Freecharge%20(1).png?dim=60x0&dpr=1.2799999713897705&q=100" alt="logo6"/>
      <div className="off">
      <h3>Flat 20%off+20% cashback on all medicines+Myntra voucher worth Rs.250</h3>
      <p>Flat 20% off+Additional 20% cashback upto Rs.600 on your 1st medicine order</p>
      <h6>Expiring in<br/> 5 days</h6>
      </div>
      </div>
     
      </div>
      <div className="box">
      <div id="b7" className="b11">
      <img src="https://cms-contents.pharmeasy.in/offer/61f3dfe3705-OlaMoney.png?dim=60x0&dpr=1.2799999713897705&q=100" alt="logo7"/>
      <div className="off">
      <h3>Flat 20%off+20% cashback on all medicines+Myntra voucher worth Rs.250</h3>
      <p>Flat 20% off+Additional 20% cashback upto Rs.600 on your 1st medicine order</p>
      <h6>Expiring in <br/>1 week </h6>
      </div>
      </div>
      </div>
      <div className="box">
      <div id="b8" className="b11">
      <img src="https://cms-contents.pharmeasy.in/offer/8cdf65ac110-mobiwiklogo.png?dim=60x0&dpr=1.2799999713897705&q=100" alt="logo8"/>
      <div className="off">
      <h3>Flat 20%off+20% cashback on all medicines+Myntra voucher worth Rs.250</h3>
      <p>Flat 20% off+Additional 20% cashback upto Rs.600 on your 1st medicine order</p>
      <h6>Expiring in <br/>1 month</h6>
      </div>
      </div>
      </div>
      <div className="box">
      <div id="b9" className="b11">
      <img src="https://cms-contents.pharmeasy.in/offer/1cc6737ebd0-PELOGO.png?dim=60x0&dpr=1.2799999713897705&q=100" alt="logo9"/>
      <div className="off">
      <h3>Flat 20%off+20% cashback on your 1st medicine order</h3>
      <p>Flat 20% off+Additional 20% cashback upto Rs.600 on your 1st medicine order</p>
      </div>
      </div>
      </div>
      <div className="box">
      <div id="b10" className="b11">
      <img src="https://cms-contents.pharmeasy.in/offer/1cc6737ebd0-PELOGO.png?dim=60x0&dpr=1.2799999713897705&q=100" alt="logo2 "/>
      <div className="off">
      <h3>Assured PE Cashback upto ₹5000</h3>
      <p>Get assured PE Cashback upto ₹5000.Minimum cart value must be ₹1499.Cashback will be credited 10 day...</p>
      </div>
      </div>
      </div>
      <div className="box">
      <div id="b15" className="b11">
      <img src="https://cms-contents.pharmeasy.in/offer/ff883fda5e7-8cb6aca7321-73c00e2e5dc-Myntra-13%20(1).png?dim=60x0&dpr=1.2799999713897705&q=100" alt="logo3"/>
      <div className="off">
      <h3>Flat 20%off+20% cashback on all medicines+Myntra voucher worth Rs.250</h3>
      <p>Flat 20% off+Additional 20% cashback upto Rs.600 on your 1st medicine order</p>
      <h6>Expiring in <br/>5 days</h6>
      </div> 
      </div>
      </div>
      <div className="box">
      <div id="b12" className="b11">
      <img src="https://cms-contents.pharmeasy.in/offer/195fbaea221-8b9fd08f47e-LOGO-33%20(1).png?dim=60x0&dpr=1.2799999713897705&q=100" alt="logo5"/>
      <div className="off">
      <h3>Flat 20%off+20% cashback on all medicines+Myntra voucher worth Rs.250</h3>
      <p>Flat 20% off+Additional 20% cashback upto Rs.600 on your 1st medicine order</p>
      <h6>Expiring in 4 days</h6>
      </div>
      </div>
      </div> 
        </div> 
        </div>
    </div>
    </>
  )
}
